/* cf-flattop-3000-black-only.js  v2 (14 Oct 2026)
 * Pete: "the only 3000mm panels are satin black flat top, make sure the calculator cant do that again".
 * James Glen makes the Flat Top 3000 x 1200 panel in Satin Black only (49313). White and Monument use 2400 panels.
 * v1 (12 Oct) only hid the dropdown option and only read the shared colour. A Monument plan (CF-FLAT-1791919037210,
 * 14 Oct) still billed a "Flat Top Panel 3000mm" Monument (fake SKU 49313m, $155.68, no variant): the gate auto-sizing
 * (findOptimalSheetForGate tries 2400 then 3000) and other solver paths set section.panelLength = 3000 with no change
 * event, and getFlatTopPanelForSize then picked the template's made-up flatTopPanel_3000_monument entry.
 * v2 clamps it inside the calculator, per section colour, at every point the sheet is chosen or used:
 *   findOptimalSheetForGate, updateSectionData('panelLength'), updateCalculationResults (before and after),
 *   getFlatTopPanelForSize (a White/Monument size over 2400 is never priced as a 3000 product),
 * and keeps the dropdown guard (option hidden + note) for every section.
 */
(function () {
  "use strict";
  if (window.__cfFlatTop3000BlackOnly || !/flat-top/i.test(location.pathname)) return;
  window.__cfFlatTop3000BlackOnly = 2;

  var NOTE_CLASS = "cf-3000-note",
    NOTE_TEXT = "3000mm panels are made in Satin Black only — this fence will be built from 2400mm panels.";

  function sharedColour() {
    var r = document.querySelector('input[name="shared-color"]:checked');
    return r ? String(r.value || "").toLowerCase() : "";
  }
  function restrictedColour(c) {
    c = String(c || "").toLowerCase();
    return c.indexOf("white") >= 0 || c.indexOf("monument") >= 0 || c.indexOf("cream") >= 0;
  }
  function sectionColour(gc, n) {
    var s = gc && gc.state && gc.state.sections && gc.state.sections[n];
    var c = "";
    try { c = gc.resolveSectionColour ? gc.resolveSectionColour(s) : ""; } catch (e) {}
    return c || (s && s.color) || sharedColour();
  }
  function restricted(gc, n) { return restrictedColour(sectionColour(gc, n)); }
  function sectionNumOf(gc, section) {
    var all = (gc.state && gc.state.sections) || {};
    for (var k in all) if (all[k] === section) return k;
    return gc.state && gc.state.currentSection;
  }
  function clampState(gc, n) {
    var s = gc.state && gc.state.sections && gc.state.sections[n];
    if (!s || !restricted(gc, n) || (parseInt(s.panelLength, 10) || 0) < 3000) return false;
    s.panelLength = "2400";
    var sel = document.getElementById("section-" + n + "-panel");
    if (sel && String(sel.value) === "3000") sel.value = "2400";
    return true;
  }

  function install(gc) {
    var P = Object.getPrototypeOf(gc);
    if (!P || P.__cf3000v2) return true;
    if (typeof P.updateCalculationResults !== "function" || typeof P.findOptimalSheetForGate !== "function") return false;
    P.__cf3000v2 = true;

    var origFind = P.findOptimalSheetForGate;
    P.findOptimalSheetForGate = function (n) {
      var r = origFind.apply(this, arguments);
      try { if ((parseInt(r, 10) || 0) >= 3000 && restricted(this, n)) return "2400"; } catch (e) {}
      return r;
    };

    if (typeof P.updateSectionData === "function") {
      var origUpd = P.updateSectionData;
      P.updateSectionData = function (n, field, value) {
        try {
          if (field === "panelLength" && (parseInt(value, 10) || 0) >= 3000 && restricted(this, n)) value = "2400";
        } catch (e) {}
        var r = origUpd.call(this, n, field, value);
        try { if (field === "color" || field === "panelLength") clampState(this, n); } catch (e) {}
        return r;
      };
    }

    var origCalc = P.updateCalculationResults;
    P.updateCalculationResults = function (n) {
      try { clampState(this, n); } catch (e) {}
      var r = origCalc.apply(this, arguments);
      try {
        // a solver path set 3000 again during the run: clamp and run once more (no flag, idempotent)
        if (clampState(this, n)) r = origCalc.apply(this, arguments);
      } catch (e) {}
      return r;
    };

    if (typeof P.getFlatTopPanelForSize === "function") {
      var origSize = P.getFlatTopPanelForSize;
      P.getFlatTopPanelForSize = function (size, section) {
        try {
          if ((Number(size) || 0) >= 3000 && restrictedColour(this.resolveSectionColour ? this.resolveSectionColour(section) : "")) {
            var n = sectionNumOf(this, section);
            if (n != null && clampState(this, n)) {
              try { console.warn("[cf-flattop-3000-black-only] section " + n + " was on 3000 in White/Monument - reset to 2400"); } catch (e2) {}
              var self = this;
              setTimeout(function () { try { self.updateCalculationResults(n); self.updateQuoteDisplay && self.updateQuoteDisplay(); } catch (e3) {} }, 0);
            }
          }
        } catch (e) {}
        return origSize.apply(this, arguments);
      };
    }
    console.log("[cf-flattop-3000-black-only] v2 installed (logic clamp)");
    return true;
  }

  function note(sel, show) {
    var host = sel.parentElement;
    if (!host) return;
    var el = host.querySelector("." + NOTE_CLASS);
    if (show) {
      if (!el) {
        el = document.createElement("div");
        el.className = NOTE_CLASS;
        el.textContent = NOTE_TEXT;
        el.style.cssText = "margin-top:6px;font-size:14px;line-height:1.4;color:#5a6b7b;";
        host.appendChild(el);
      }
    } else if (el) el.parentNode.removeChild(el);
  }
  function apply() {
    var gc = window.glassCalculator;
    var sels = document.querySelectorAll('select[id^="section-"][id$="-panel"]');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i], opt = sel.querySelector('option[value="3000"]');
      if (!opt) continue;
      var n = (String(sel.id).match(/^section-(\d+)-panel$/) || [])[1];
      var lock = n && gc ? restricted(gc, n) : restrictedColour(sharedColour());
      if (lock) {
        if (String(sel.value) === "3000") {
          sel.value = "2400";
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
        opt.disabled = true; opt.hidden = true; note(sel, true);
      } else {
        opt.disabled = false; opt.hidden = false; note(sel, false);
      }
      if (lock && gc && n && clampState(gc, n)) {
        try { gc.updateCalculationResults(n); gc.updateQuoteDisplay && gc.updateQuoteDisplay(); } catch (e) {}
      }
    }
  }
  var t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () { t = null; try { apply(); } catch (e) {} }, 80);
  }

  var tries = 0;
  (function tryInstall() {
    var gc = window.glassCalculator;
    var ok = false;
    try { ok = gc && install(gc); } catch (e) {}
    if (!ok && ++tries < 100) setTimeout(tryInstall, 100);
  })();

  function start() {
    schedule();
    document.addEventListener("change", function (e) {
      var n = e && e.target;
      if (n && (n.name === "shared-color" || /^section-\d+-(panel|color)$/.test(String(n.id || n.name || "")))) schedule();
    }, true);
    document.addEventListener("click", function () { schedule(); }, true);
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    console.log("[cf-flattop-3000-black-only] v2 installed (dropdown)");
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
